import { useState } from 'react';
import { Form, Card, Row, Col, Button, Image } from 'react-bootstrap';
import icArea from './assets/img/ic-city.svg';

const CompanyAddJobs = ({ formData = {}, handleChange, handleJobsSubmit, isEditPage }) => { // ✅ Ensure formData has a default value
    const [isEditing, setIsEditing] = useState(!isEditPage); // ✅ If adding, fields are enabled
    const [tempFormData, setTempFormData] = useState({ ...formData }); // ✅ Store initial values

    // ✅ Enable editing mode
    const handleEditClick = () => {
        setIsEditing(true);
        setTempFormData({ ...formData }); // ✅ Store previous values
    };

    // ✅ Save changes and disable editing
    const handleSaveClick = async (e) => {
        e.preventDefault();
        if (typeof handleJobsSubmit === 'function') { // ✅ Ensure it's a function before calling
            await handleJobsSubmit(e);
            setIsEditing(false); // ✅ Exit edit mode after saving
        } else {
            console.error('Error: handleJobsSubmit is not a function.');
        }
    };

    // ✅ Cancel editing and restore previous values
    const handleCancelClick = () => {
        setIsEditing(false);
        Object.keys(tempFormData).forEach((key) => {
            handleChange({ target: { name: key, value: tempFormData[key] } });
        });
    };

    return (
        <>
            <Card className="mb-4">
                <Card.Body>
                    <Row>
                        <Col md={12}>
                            {isEditPage && (
                                <div className="float-end">
                                    {!isEditing ? (
                                        <Button variant="outline-secondary" className="btn-sm" onClick={handleEditClick}>Edit</Button>
                                    ) : (
                                        <>
                                            <Button variant="outline-secondary" className="btn-sm me-2" onClick={handleCancelClick}>Cancel</Button>
                                            <Button variant="primary" className="btn-sm" onClick={handleSaveClick}>Save</Button>
                                        </>
                                    )}
                                </div>
                            )}
                            <h3><span className="item-number">2.</span> Job preferences</h3>
                            <hr />
                        </Col>
                    </Row>            
                    <Row>
                        <Col md={4}>
                            {/* Open for Student Jobs */}
                            <Card>
                                <Card.Header>
                                    <Form.Group controlId="openedStudent" className="d-flex justify-content-between w-100">
                                        <Form.Label className="fw-bold mb-0">Open for student jobs</Form.Label>
                                        <div className="d-flex align-items-center">
                                            <label className="switch me-2 mb-0">
                                                <input
                                                    type="checkbox"
                                                    name="openedStudent"
                                                    checked={formData.openedStudent}
                                                    onChange={handleChange}
                                                    disabled={!isEditing}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                            <span>
                                                {formData.openedStudent ? 'Yes' : 'No'}
                                            </span>
                                        </div>
                                    </Form.Group>
                                </Card.Header>
                                <Card.Body className="p-3 pt-2">
                                    {/* Student Job Areas */}
                                    {isEditing ? (
                                        formData.openedStudent && (
                                            <>
                                                {formData.city
                                                    ? formData.city
                                                    : formData.address
                                                        ? (() => {
                                                            const parts = formData.address.split(',');
                                                            return parts.length >= 2
                                                            ? parts[parts.length - 2].trim()
                                                            : 'N/A';
                                                        })()
                                                        : 'N/A'
                                                }

                                                <Form.Group controlId="studentJobAreas">
                                                    <Form.Label className="fw-bold mt-2 mb-2">Student job areas</Form.Label>
                                                    <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="studentJobAreas"
                                                    value={formData.studentJobAreas || ''}
                                                    onChange={handleChange}
                                                    placeholder="e.g. Hospitality, Retail, Events, Delivery, Office support..."
                                                    />
                                                </Form.Group>

                                            </>
                                        )
                                    ) : (
                                        // Not editing
                                        formData.openedStudent && (
                                            <>
                                                <div className="icon-text mt-2">
                                                    <span className="icon" aria-hidden="true">
                                                        <Image src={icArea} alt="Student job Areas" />
                                                    </span>
                                                    <span className="text">
                                                        Which Areas
                                                        <br />
                                                        <strong>
                                                            <>
                                                                {formData.city
                                                                ? formData.city
                                                                : formData.address
                                                                    ? (() => {
                                                                        const parts = formData.address.split(',');
                                                                        return parts.length >= 2
                                                                        ? parts[parts.length - 2].trim()
                                                                        : 'N/A';
                                                                    })()
                                                                    : 'N/A'
                                                                }
                                                            </>
                                                        </strong>
                                                    </span>
                                                </div>
                                                <div className="icon-text mt-3">
                                                    <span className="text">
                                                        Which Corporate Areas
                                                        <br />
                                                        <strong>
                                                            <>
                                                                <div className="">
                                                                    {formData.studentJobAreas?.trim()
                                                                        ? formData.studentJobAreas
                                                                        : 'N/A'
                                                                    }
                                                                </div>
                                                            </>
                                                        </strong>
                                                    </span>
                                                </div>
                                            </>
                                        )
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            {/* Open for world traveler */}
                            <Card>
                                <Card.Header>
                                    <Form.Group controlId="openedWorldTraveler" className="d-flex justify-content-between w-100">
                                        <Form.Label className="fw-bold mb-0">Open for World Traveler</Form.Label>
                                        <div className="d-flex align-items-center">
                                            <label className="switch me-2 mb-0">
                                                <input
                                                    type="checkbox"
                                                    name="openedWorldTraveler"
                                                    checked={formData.openedWorldTraveler}
                                                    onChange={handleChange}
                                                    disabled={!isEditing}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                            <span>
                                                {formData.openedWorldTraveler ? 'Yes' : 'No'}
                                            </span>
                                        </div>
                                    </Form.Group>
                                </Card.Header>
                                <Card.Body className="p-3 pt-2">
                                    {/* World Traveler Areas */}
                                    {isEditing ? (                                       
                                        formData.openedWorldTraveler && (
                                            <>
                                                {formData.city
                                                    ? formData.city
                                                    : formData.address
                                                    ? (() => {
                                                        const parts = formData.address.split(',');
                                                        return parts.length >= 2
                                                            ? parts[parts.length - 2].trim()
                                                            : 'N/A';
                                                        })()
                                                    : 'N/A'
                                                }

                                                <Form.Group controlId="worldTravelerAreas">
                                                    <Form.Label className="fw-bold mt-2 mb-2">World traveler areas</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        name="worldTravelerAreas"
                                                        value={formData.worldTravelerAreas || ''}
                                                        onChange={handleChange}
                                                        placeholder=""
                                                    />
                                                </Form.Group>
                                            </>
                                        )
                                    ) :(
                                        // Not editing
                                        formData.openedWorldTraveler && (
                                            <>
                                                <div className="icon-text mt-2">
                                                    <span className="icon" aria-hidden="true">
                                                        <Image src={icArea} alt="World Traveler Areas" />
                                                    </span>
                                                    <span className="text">
                                                        Which Areas
                                                        <br />
                                                        <strong>
                                                            <>
                                                                {formData.city
                                                                    ? formData.city
                                                                    : formData.address
                                                                        ? (() => {
                                                                            const parts = formData.address.split(',');
                                                                            return parts.length >= 2
                                                                                ? parts[parts.length - 2].trim()
                                                                                : 'N/A';
                                                                        })()
                                                                    : 'N/A'
                                                                }
                                                            </>
                                                        </strong>
                                                    </span>
                                                </div>
                                                <div className="icon-text mt-3">
                                                    <span className="text">
                                                        Which Corporate Areas
                                                        <br />
                                                        <strong>
                                                        <>
                                                            <div className="">
                                                                {formData.worldTravelerAreas?.trim()
                                                                    ? formData.worldTravelerAreas
                                                                    : 'N/A'
                                                                }
                                                            </div>
                                                        </>
                                                        </strong>
                                                    </span>
                                                </div>
                                            </>
                                        )
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            {/* Open for English Speaking Only */}
                            <Card>
                                <Card.Header>
                                    <Form.Group controlId="openedEnglishSpeaking" className="d-flex justify-content-between w-100">
                                        <Form.Label className="fw-bold mb-0">Open for English Speaking Only</Form.Label>
                                        <div className="d-flex align-items-center">
                                            <label className="switch me-2 mb-0">
                                                <input
                                                    type="checkbox"
                                                    name="openedEnglishSpeaking"
                                                    checked={formData.openedEnglishSpeaking}
                                                    onChange={handleChange}
                                                    disabled={!isEditing}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                            <span>
                                                {formData.openedEnglishSpeaking ? 'Yes' : 'No'}
                                            </span>
                                        </div>
                                    </Form.Group>
                                </Card.Header>
                                <Card.Body className="p-3 pt-2">
                                    {/* English Speaking Areas */}
                                    {isEditing ? (
                                        formData.openedEnglishSpeaking && (
                                            <>
                                                {formData.city
                                                    ? formData.city
                                                    : formData.address
                                                    ? (() => {
                                                        const parts = formData.address.split(',');
                                                        return parts.length >= 2
                                                            ? parts[parts.length - 2].trim()
                                                            : 'N/A';
                                                        })()
                                                    : 'N/A'
                                                }

                                                <Form.Group controlId="enSpeakingAreas">
                                                    <Form.Label className="fw-bold mt-2 mb-2">English speaking areas</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        name="enSpeakingAreas"
                                                        value={formData.enSpeakingAreas || ''}
                                                        onChange={handleChange}
                                                        placeholder=""
                                                    />
                                                </Form.Group>
                                            </>
                                        )
                                    ) : (
                                        // Not editing
                                        formData.openedEnglishSpeaking && (
                                            <>
                                                <div className="icon-text mt-2">
                                                    <span className="icon" aria-hidden="true">
                                                        <Image src={icArea} alt="English Speaking Areas" />
                                                    </span>
                                                    <span className="text">
                                                        Which Areas
                                                        <br />
                                                        <strong>
                                                            
                                                                <>
                                                                    {formData.city
                                                                        ? formData.city
                                                                        : formData.address
                                                                            ? (() => {
                                                                                const parts = formData.address.split(',');
                                                                                return parts.length >= 2
                                                                                    ? parts[parts.length - 2].trim()
                                                                                    : 'N/A';
                                                                            })()
                                                                        : 'N/A'
                                                                    }
                                                                </>
                                                            
                                                        </strong>
                                                    </span>
                                                </div>
                                                <div className="icon-text mt-3">
                                                    <span className="text">
                                                        Which Corporate Areas
                                                        <br />
                                                        <strong>
                                                            <>
                                                                <div className="">
                                                                    {formData.enSpeakingAreas?.trim()
                                                                        ? formData.enSpeakingAreas
                                                                        : 'N/A'
                                                                    }    
                                                                </div>
                                                            </>
                                                        </strong>
                                                    </span>
                                                </div>
                                            </>
                                        )
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </>
    );
};

export default CompanyAddJobs;
